export default __webpack_public_path__ + "static/media/image-boleto.37e5d343.svg";